import { jsx as _jsx } from "react/jsx-runtime";
import { LinkIcon } from "../../../../icons/LinkIcon";
import { LinkMenu } from "./LinkMenu";
import { isLinkActive } from "./link-utilities";
export const linkToolbarControl = {
    name: "link",
    icon: _jsx(LinkIcon, { "aria-hidden": "true" }),
    isActive: isLinkActive,
    popover: (props) => _jsx(LinkMenu, { ...props })
};
